import { render, staticRenderFns } from "./OsCard.vue?vue&type=template&id=7a37aca4&scoped=true&"
import script from "./OsCard.vue?vue&type=script&lang=js&"
export * from "./OsCard.vue?vue&type=script&lang=js&"
import style0 from "./OsCard.vue?vue&type=style&index=0&id=7a37aca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a37aca4",
  null
  
)

export default component.exports